<template>
  <div class="show-fines-modal">
    <m-items
      :modal-confirm="true"
      :active="isShowConfirmModal"
      :modal-title="'Удаление штрафа'"
      :modal-description="'При удалении штрафа сумма средств на личном счете сотрудника изменится'"
      @close="isShowConfirmModal = false"
      @removeItemRequest="removeItemRequest"
    />
    <m-write-fine
      :calc-data="calcData"
      :record="record"
      :active="isShowWriteFineModal"
      :edit-fine-data="editFineDataLocal"
      @close="isShowWriteFineModal = false"
      @editFine="editFine"
      @createFine="createFine"
    />
    <b-modal
      id="calculationsShowFinesModal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @show="onShowModal"
      @close="localActive = false"
    >
      <svg
        class="show-fines-modal-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="show-fines-modal-fullname">
        <div class="show-fines-modal-fullname-description">
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.9902 16.0625C13.9902 16.6148 14.4379 17.0625 14.9902 17.0625C15.5425 17.0625 15.9902 16.6148 15.9902 16.0625H13.9902ZM11.2513 10.9863V9.98628V10.9863ZM4.73896 10.9863V9.98628V10.9863ZM1 14.9745H0H1ZM0 16.0625C0 16.6148 0.447715 17.0625 1 17.0625C1.55228 17.0625 2 16.6148 2 16.0625H0ZM15.9902 16.0625V14.9745H13.9902V16.0625H15.9902ZM15.9902 14.9745C15.9902 13.6716 15.5056 12.4102 14.6246 11.4705L13.1656 12.8383C13.687 13.3945 13.9902 14.1619 13.9902 14.9745H15.9902ZM14.6246 11.4705C13.7416 10.5286 12.5297 9.98628 11.2513 9.98628V11.9863C11.9561 11.9863 12.6462 12.2843 13.1656 12.8383L14.6246 11.4705ZM11.2513 9.98628H4.73896V11.9863H11.2513V9.98628ZM4.73896 9.98628C3.46052 9.98628 2.24859 10.5286 1.36558 11.4705L2.82465 12.8383C3.34403 12.2843 4.03413 11.9863 4.73896 11.9863V9.98628ZM1.36558 11.4705C0.484619 12.4102 0 13.6716 0 14.9745H2C2 14.1619 2.30323 13.3945 2.82465 12.8383L1.36558 11.4705ZM0 14.9745V16.0625H2V14.9745H0ZM9.95503 3.99117C9.95503 5.09086 9.06355 5.98234 7.96386 5.98234V7.98234C10.1681 7.98234 11.955 6.19543 11.955 3.99117H9.95503ZM7.96386 5.98234C6.86417 5.98234 5.97269 5.09086 5.97269 3.99117H3.97269C3.97269 6.19543 5.7596 7.98234 7.96386 7.98234V5.98234ZM5.97269 3.99117C5.97269 2.89148 6.86417 2 7.96386 2V0C5.7596 0 3.97269 1.78691 3.97269 3.99117H5.97269ZM7.96386 2C9.06355 2 9.95503 2.89148 9.95503 3.99117H11.955C11.955 1.78691 10.1681 0 7.96386 0V2Z"
              fill="#8E9CBB"
            />
          </svg>
          <div class="show-fines-modal-fullname-description-text">{{ record.employee.value }}</div>
        </div>
        <c-button label="Добавить штраф" size="small" @click="showModalAddNewFine" />
      </div>
      <div class="show-fines-modal-header show-fines-modal-header-red">
        <div class="show-fines-modal-header-title">Штрафы</div>
        <div class="show-fines-modal-header-count">
          <div class="show-fines-modal-header-count-text">{{ getCountForHeader() }}</div>
        </div>
        <div class="show-fines-modal-header-amount">{{ getCommonAmount() }}<span> ฿</span></div>
      </div>
      <div v-if="itemsLocal.length > 0" class="show-fines-modal-search">
        <c-input
          id="show-fines-modal-search-input"
          v-model="searchLocal"
          class="show-fines-modal-search-input"
          placeholder="Поиск"
          icon="search"
          type="text"
          :clearable="true"
        />
      </div>
      <div id="show-fines-modal-items" class="show-fines-modal-items" @scroll="setShadowSummaryItems">
        <div v-for="(item, itemIndex) in itemsLocal" :key="itemIndex" class="show-fines-modal-items-item"  v-if="item.isShow">
          <template v-if="item.isShow">
            <div class="show-fines-modal-items-item-desc">{{ item.reason }}</div>
            <div class="d-flex align-items-center">
              <div class="show-fines-modal-items-item-date">{{ item.date }}</div>
              <div class="show-fines-modal-items-item-amount">{{ item.amount }}<span> ฿</span></div>
              <div class="show-fines-modal-items-item-buttons">
                <c-button
                  v-if="item.calc_id !== null && item.calc_id !== undefined"
                  :key="item.calc_id"
                  v-b-popover.html="{
                    container: '#calculationsShowFinesModal',
                    trigger: 'hover blur',
                    boundary: 'window',
                    content: 'Перейти в сохранённый расчёт 12',
                    placement: 'top',
                  }"
                  class="show-fines-modal-items-item-buttons-calculate"
                  size="iconic"
                  icon="calculate"
                  @click="openCalc(item.calc_id)"
                />
                <c-button
                  v-b-popover.html="{
                    container: '#calculationsShowFinesModal',
                    trigger: 'hover blur',
                    boundary: 'window',
                    content: 'Редактировать',
                    placement: 'top',
                  }"
                  class="show-fines-modal-items-item-buttons-edit"
                  size="iconic"
                  icon="edit"
                  @click="showEditFineModal(item, itemIndex)"
                />
                <c-button
                  v-if="!item.is_external"
                  v-b-popover.html="{
                    container: '#calculationsShowFinesModal',
                    trigger: 'hover blur',
                    boundary: 'window',
                    content: 'Удалить',
                    placement: 'top',
                  }"
                  class="show-fines-modal-items-item-buttons-trash"
                  size="iconic"
                  icon="trash"
                  @click="showConfirmRemoveModal(itemIndex)"
                />
              </div>
            </div>
          </template>
        </div>
        <div v-if="isShowSearchEmptyMessage || itemsLocal.length === 0" class="show-fines-modal-items-empty">
          Штрафов не найдено
        </div>
      </div>
      <div id="show-fines-modal-items-shadow-bottom" class="show-fines-modal-items-shadow-bottom"></div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";
import ModalPositionsItems from "@/pages/positions/items-modal";
import WriteFineModal from "@/pages/calculations/create/additions/modal-production-write-fine";

export default {
  name: "show-premium-modal",
  components: {
    "c-input": Input,
    "c-button": Button,
    "m-items": ModalPositionsItems,
    "m-write-fine": WriteFineModal,
  },
  props: ["active", "calcData", "record"],
  data() {
    return {
      localActive: false,
      itemsLocal: [],
      sumFinesLocalValue: 0,
      searchLocal: "",
      isShowSearchEmptyMessage: false,
      isShowConfirmModal: false,
      isShowWriteFineModal: false,
      removeItemIndex: null,
      editFineDataLocal: null,
      editFineIndexLocal: null,
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        setTimeout(() => {
          this.searchLocal = "";
        }, 250);
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
    searchLocal(value) {
      this.itemsLocal.forEach((item) => {
        if (value.length === 0) {
          item.isShow = true;
          return;
        }
        if (item.reason.toString().toLowerCase().includes(value.toString().toLowerCase())) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });

      this.isShowSearchEmptyMessage = !this.itemsLocal.some((item) => item.isShow);

      setTimeout(() => {
        this.setShadowSummaryItems();
      }, 200);
    },
  },

  mounted() {
    // console.log(this.record.prize)
  },

  methods: {
    showModalAddNewFine() {
      this.editFineDataLocal = null;
      this.isShowWriteFineModal = true;
    },

    showEditFineModal(fine, editFineIndex) {
      this.editFineIndexLocal = editFineIndex;
      this.editFineDataLocal = fine;
      this.isShowWriteFineModal = true;
    },

    editFine(newFineData) {

      console.log('fine');
      let sum = 0;

      this.record.fine.items[this.editFineIndexLocal] = {
        amount: newFineData.amount,
        author_id: newFineData.author_id === undefined ? null : newFineData.author_id,
        reason: newFineData.reason,
        reason_id: newFineData.reason_id,
        comment: newFineData.comment,
        date: newFineData.date,
        is_external: newFineData.is_external,
        calc_id: newFineData.calc_id,
      };

       

      this.record.fine.items.forEach((fine) => {
        sum += Number(fine.amount);
      });

      this.record.fine.value = sum;

      this.itemsLocal = this.record.fine.items.map((item) => {
        let date = "";
        if (!item.date) {
          date = moment().format("DD.MM.YYYY");
        } else if (moment(item.date).isValid()) {
          date = moment(item.date).format("DD.MM.YYYY");
        } else {
          date = item.date;
        }

        return {
          reason_id: item.reason_id,
          reason: item.reason,
          date,
          amount: item.amount,
          comment: item.comment,
          author_id: item.author_id ? item.author_id : null,
          isShow: true,
          is_external: item.is_external,
          calc_id: item.calc_id,
        };
      });

      let sumFines = 0;
      let sumPrizes = 0;
      this.record.prize.items.forEach((item) => {
        if (!item.is_external) sumPrizes += Number(item.amount);
      });
      this.record.fine.items.forEach((item) => {
        if (!item.is_external) sumFines += Number(item.amount);
      });

   //   this.record.to_payoff.value =
     //   Number(this.record.personal_account_transactions.value) + Number(sumPrizes) - Number(sumFines);

      this.$emit("updateFines", {record:this.record})
    },

    createFine(newFineData) {
      console.log('fine');
      let sum = 0;

      this.record.fine.items.push({
        amount: newFineData.amount,
        author_id: newFineData.author_id === undefined ? null : newFineData.author_id,
        reason: newFineData.reason,
        reason_id: newFineData.reason_id,
        comment: newFineData.comment,
        date: newFineData.date,
        is_external: newFineData.is_external,
        calc_id: newFineData.calc_id,
      });


      this.record.fine.items.forEach((fine) => {
        sum += Number(fine.amount);
      });

      this.record.fine.value = sum;

      this.itemsLocal = this.record.fine.items.map((item) => {
        let date = "";
        if (!item.date) {
          date = moment().format("DD.MM.YYYY");
        } else if (moment(item.date).isValid()) {
          date = moment(item.date).format("DD.MM.YYYY");
        } else {
          date = item.date;
        }

        return {
          reason_id: item.reason_id,
          reason: item.reason,
          date,
          amount: item.amount,
          comment: item.comment,
          author_id: item.author_id ? item.author_id : null,
          isShow: true,
          is_external: item.is_external,
          calc_id: item.calc_id,
        };
      });

      let sumFines = 0;
      let sumPrizes = 0;
      this.record.prize.items.forEach((item) => {
        if (!item.is_external) sumPrizes += Number(item.amount);
      });
      this.record.fine.items.forEach((item) => {
        if (!item.is_external) sumFines += Number(item.amount);
      });

      this.record.to_payoff.value =
        Number(this.record.personal_account_transactions.value) + Number(sumPrizes) - Number(sumFines);

      console.log('update fines');
      this.$emit("updateFines", {record:this.record})
    },

    openCalc(calcId) {
      alert(calcId);
      this.$router.resolve({ name: "save-calculation-production", query: { calc_id: calcId } });
    },

    showConfirmRemoveModal(itemIndex) {
      this.removeItemIndex = itemIndex;
      this.isShowConfirmModal = true;
    },
    removeItemRequest() {
      if (this.removeItemIndex !== null) {
        this.record.fine.value -= Number(this.itemsLocal[this.removeItemIndex].amount);
        this.record.to_payoff.value += Number(this.itemsLocal[this.removeItemIndex].amount);
        this.itemsLocal.splice(this.removeItemIndex, 1);
        this.record.fine.items.splice(this.removeItemIndex, 1);
        this.$emit("updateFines", {record:this.record})
      }
      this.isShowConfirmModal = false;
    },

    setShadowSummaryItems() {
      const shadowBottomElement = document.getElementById("discipline-summary-modal-items-shadow-bottom");
      const searchElement = document.getElementById("discipline-summary-modal-search-input");
      const element = document.getElementById("discipline-summary-modal-items");
      if (element !== null) {
        if (element.scrollHeight > element.clientHeight) {
          // top shadow items
          if (element.scrollTop !== 0) {
            searchElement.classList.add("discipline-summary-modal-search-shadow-top");
          } else if (element.scrollTop === 0) {
            searchElement.classList.remove("discipline-summary-modal-search-shadow-top");
          }
          // bottom shadow items
          if (element.scrollTop + element.clientHeight !== element.scrollHeight) {
            shadowBottomElement.classList.add("discipline-summary-modal-items-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("discipline-summary-modal-items-shadow-bottom-active");
          }
        } else {
          searchElement.classList.remove("discipline-summary-modal-search-shadow-top");
          shadowBottomElement.classList.remove("discipline-summary-modal-items-shadow-bottom-active");
        }
      }
    },

    onShowModal() {
      this.itemsLocal = this.record.fine.items.map((item) => {
        let date = "";
        if (!item.date) {
          date = moment().format("DD.MM.YYYY");
        } else if (moment(item.date).isValid()) {
          date = moment(item.date).format("DD.MM.YYYY");
        } else {
          date = item.date;
        }

        return {
          reason: item.reason,
          reason_id: item.reason_id,
          author_id: item.author_id,
          date,
          amount: item.amount,
          comment: item.comment,
          isShow: true,
          is_external: item.is_external,
          calc_id: item.calc_id,
        };
      });

      this.sumFinesLocalValue = this.itemsLocal.reduce((a, b) => a + Number(b.amount), 0);

      setTimeout(() => {
        this.setShadowSummaryItems();
      }, 100);
    },

    closeModal() {
      this.localActive = false;
    },

    getCountForHeader() {
      return this.itemsLocal.length;
    },

    getCommonAmount() {
      let amount = 0;
      this.itemsLocal.forEach((item) => {
        amount += Number(item.amount);
      });
      return this.formatAmount(amount);
    },

    formatAmount(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.show-fines-modal {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-fullname {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 28px;

    &-description {
      display: flex;
      align-items: center;

      &-text {
        margin-left: 11px;
        font-size: 13px;
        line-height: 16px;
      }
    }
  }

  &-header {
    display: flex;
    align-items: center;

    @media screen and (max-width: 700px) {
      margin-top: 3px;
    }

    &-title {
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
    }

    &-count {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      width: 28px;
      height: 20px;
      background: #f5f7fa;
      border-radius: 30px;

      &-text {
        font-weight: bold;
        font-size: 12px;
        line-height: 120%;
      }
    }

    &-amount {
      margin-left: auto;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;

      & span {
        font-weight: 500;
        font-size: 14px;
      }
    }

    &-red {
      & .show-fines-modal-header-title {
        color: #ff238d;
      }

      ::v-deep & .show-fines-modal-header-count-text {
        color: #ff238d;
      }
    }

    &-green {
      & .show-fines-modal-header-title {
        color: #12c971;
      }

      ::v-deep & .show-fines-modal-header-count-text {
        color: #12c971;
      }
    }
  }

  &-search {
    position: relative;
    margin-top: 24px;

    &-shadow-top {
      &:before {
        content: "";
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
        position: absolute;
        bottom: -50px;
        left: 0;
        pointer-events: none;
        z-index: 10;
        height: 30px;
        width: 100%;
      }
    }

    &-input {
      ::v-deep & .c-input-input::placeholder {
        font-style: italic;
      }

      ::v-deep & .c-input-action_clear {
        margin-top: 3px;
      }
    }
  }

  &-items {
    position: relative;
    margin-top: 21px;
    max-height: 377px;
    overflow-y: auto;
    width: calc(100% + 15px);

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 150px);
      width: calc(100% + 10px);
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
      border-radius: 4px;
    }

    &-item {
      border-top: solid 1px #dfe4ef;
      border-bottom: solid 1px #dfe4ef;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 14px;
      margin-top: -1px;
      padding: 9px 12px;

      @media screen and (max-width: 320px) {
        padding: 8px;
      }

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        border-bottom: solid 1px #dfe4ef;
      }

      &-desc {
        font-size: 13px;
        max-width: 245px;

        @media screen and (max-width: 400px) {
          max-width: 220px;
        }
        @media screen and (max-width: 369px) {
          max-width: 180px;
        }
      }

      &-date {
        margin-left: auto;
      }

      &-amount {
        display: flex;
        width: 71px;
        justify-content: flex-end;
        font-weight: 500;
        font-size: 13px;
        line-height: 100%;
        margin-left: auto;
      }

      &-buttons {
        display: flex;
        align-items: center;
        min-width: 80px;
        justify-content: flex-end;

        &-calculate {
          margin-left: 25px;
        }

        &-edit {
          margin-left: 15px;
        }

        &-trash {
          margin-left: 15px;
        }
      }
    }

    &-empty {
      padding: 0 12px;

      @media screen and (max-width: 320px) {
        padding: 0 8px;
      }
    }

    &-shadow-bottom {
      content: "";
      position: absolute;
      background: transparent;
      bottom: 30px;
      left: 20px;
      pointer-events: none;
      height: 30px;
      width: calc(100% - 50px);
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }
  }
}
</style>
